import type { ColDef } from "ag-grid-community";
import { useMemo } from "react";

import { getProductArea, type Product } from "@/shared/models/Product";

type BeamRow = {
	Plate: string;
	p1: string | null;
	p2: string | null;
	p3: string | null;
	p4: string | null;
	p5: string | null;
	p6: string | null;
	p7: string | null;
};

const PLATE_CELL_STYLE = { fontWeight: 600, color: "rgba(0,0,0,0.6)" };

// Headers hidden via headerHeight={0} on the grid — orientation is conveyed
// by the Avenue/River caption row above the table.
const BEAM_COLUMN_DEFS: ColDef[] = [
	{ field: "Plate", headerName: "", width: 80, cellStyle: PLATE_CELL_STYLE },
	{ field: "p1", headerName: "", flex: 1 },
	{ field: "p2", headerName: "", flex: 1 },
	{ field: "p3", headerName: "", flex: 1 },
	{ field: "p4", headerName: "", flex: 1 },
	{ field: "p5", headerName: "", flex: 1 },
	{ field: "p6", headerName: "", flex: 1 },
	{ field: "p7", headerName: "", flex: 1 },
];

export const useBeamPositionsTableData = (product: Product | null) => {
	const rowData = useMemo<BeamRow[]>(() => {
		const upper: (string | null)[] = Array(7).fill(null);
		const lower: (string | null)[] = Array(7).fill(null);
		if (product && getProductArea(product) === "punch") {
			for (const bp of product.BeamPositions) {
				const slot = bp.PositionOrder - 1;
				if (slot < 0 || slot > 6) continue;
				const value = bp.PositionValue?.trim() ? bp.PositionValue : null;
				if (bp.Plate === "U") upper[slot] = value;
				else if (bp.Plate === "L") lower[slot] = value;
			}
		}
		const toRow = (label: string, v: (string | null)[]): BeamRow => ({
			Plate: label,
			p1: v[0],
			p2: v[1],
			p3: v[2],
			p4: v[3],
			p5: v[4],
			p6: v[5],
			p7: v[6],
		});
		return [toRow("Upper", upper), toRow("Lower", lower)];
	}, [product]);

	return { columnDefs: BEAM_COLUMN_DEFS, rowData };
};
